<div class="reference-point-input-container">
    <div style="flex: 1;">
        <input type="text" class="reference-point-input" 
            placeholder="Buscar dirección" 
            [(ngModel)]="searchAddress"
            (input)="onSearchInput()"
            (keyup.enter)="searchLocationConPlaces(true)"
            (focus)="onInputFocus()"
            (blur)="onInputNoFocus()"
            [disabled]="!isPlacesLibraryLoaded || isSearchDisabled"
            autocomplete="off">

        <div class="directions-list" *ngIf="inputFocused && showSuggestions && directionsSuggestions.length > 0">
            <div class="directions-item" 
                *ngFor="let suggestion of directionsSuggestions"
                (click)="selectSuggestion(suggestion)">
                <div class="directions-data">
                    <div class="directions-name">{{ suggestion.name || suggestion.address_components?.[0]?.short_name }}</div>
                    <div class="directions-place">{{ suggestion.formatted_address }}</div>
                </div>
            </div>
        </div>
    </div>
</div>